.footer {
  margin-left: auto;
}
